// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".marginbottom[data-v-0e21c01e] {\n  margin-bottom: 12px;\n}\n[data-v-0e21c01e] .el-upload {\n  width: 100% !important;\n}\n[data-v-0e21c01e] .el-upload .el-upload-dragger {\n  width: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
